<div class="ni-home ni-home-search-app">
  <app-search-no-result [searchResult]="searchResult" [searchParams]="searchParams"></app-search-no-result>
</div>
